import { render, staticRenderFns } from "./sidebarMenu.vue?vue&type=template&id=8436b91c&scoped=true"
import script from "./sidebarMenu.vue?vue&type=script&lang=js"
export * from "./sidebarMenu.vue?vue&type=script&lang=js"
import style0 from "./sidebarMenu.vue?vue&type=style&index=0&id=8436b91c&prod&lang=less"
import style1 from "./sidebarMenu.vue?vue&type=style&index=1&id=8436b91c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8436b91c",
  null
  
)

export default component.exports